import { Badge, type BadgeTone } from '@astral/ui';
import type { Role } from '@astral/shared';
import { useT, type TranslationKey } from '../providers/I18nProvider.js';

const TONE: Record<Role, BadgeTone> = {
  OWNER: 'accent',
  ADMIN: 'warning',
  USER: 'neutral',
};

/** A localized badge showing a user's role. */
export function RoleBadge({ role }: { role: Role }): JSX.Element {
  const t = useT();
  return <Badge tone={TONE[role]}>{t(`roles.${role}` as TranslationKey)}</Badge>;
}
